/** Some sources hand back URLs with whitespace or zero-width characters
 *  around them. Angular's sanitizer then treats the link as unsafe and
 *  rewrites it to `unsafe:…`, so it goes nowhere; trimmed, it's fine. */
export function cleanUrl(value: unknown): string | null {
  if (typeof value !== 'string') return null;
  const url = value.replace(/^[\s​-‍⁠﻿]+|[\s​-‍⁠﻿]+$/g, '');
  return url || null;
}

/** The domain to show, without "www.": the API's domain_name when it came
 *  back, else read off the URL. */
export function displayHost(domainName: string | null, url: string): string {
  if (domainName) return domainName.replace(/^www\./, '');
  try {
    return new URL(url).hostname.replace(/^www\./, '');
  } catch {
    return url;
  }
}
